/** Map aggregator payment status → Russian label for UI */
export function mapPaymentStatus(status: string): { label: string; color: string } {
  const map: Record<string, { label: string; color: string }> = {
    pending: { label: 'Ожидает оплаты', color: 'orange' },
    waiting_for_capture: { label: 'Ожидает подтверждения', color: 'blue' },
    succeeded: { label: 'Успешно', color: 'green' },
    paid: { label: 'Успешно', color: 'green' },
    canceled: { label: 'Отменён', color: 'default' },
    cancelled: { label: 'Отменён', color: 'default' },
    refunded: { label: 'Возврат', color: 'purple' },
  }
  return map[status] || { label: status || '—', color: 'default' }
}
